import { render, staticRenderFns } from "./header_mobil.vue?vue&type=template&id=06affe7a&scoped=true"
import script from "./header_mobil.vue?vue&type=script&lang=js"
export * from "./header_mobil.vue?vue&type=script&lang=js"
import style0 from "./header_mobil.vue?vue&type=style&index=0&id=06affe7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06affe7a",
  null
  
)

export default component.exports